import React from 'react';

import { Loader } from '.';
import {IframePage} from "../types/iframe";
import {withParamsFrame} from "../HOCs";

const Profile: React.FC<IframePage> = ({ params }) => {
    const [loaded, setLoaded] = React.useState(false);

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={`${!loaded ? 'min-h-[auto]' : 'page-iframe'}`} src={`https://lk.market/profile${params}`}
                    title="Profile"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}

                    onLoad={() => setLoaded(true)}
                ></iframe>
            </div>
            {
                !loaded && <Loader />
            }
        </>
    );
};

export default withParamsFrame(Profile);
